import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-ticket-notice',
  name: '购买须知',
  icon: '须',
  group: '门票详情',
  description: '票种“购买须知”：预定信息与使用规则。',
  defaultProps: {
    title: '购买须知',
    showReminder: true,
    showRules: true
  }
}
